<template>
    <v-snackbar
            v-model="show"
            color="success"
            :top="true"
            :multi-line="true"
            :timeout="notification.timeout"
    >
        {{ notification.text }}
        <v-btn
                text
                dark
                @click="close()"
        >
            {{ $t('controls.close') }}
        </v-btn>
    </v-snackbar>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Notification',
    computed: {
      ...mapGetters({
        notification: 'notification/getNotification'
      }),
      show: {
        get() {
          return this.notification.show
        },
        set() {
          this.$store.commit('notification/closeNotification')
        }
      }
    },
    methods: {
      close () {
        this.$store.commit('notification/closeNotification')
      }
    }
  }
</script>
